export default __webpack_public_path__ + "static/media/Ecrm.90d15203.svg";